import { call, put, putResolve, takeEvery, take,all,select, takeLatest } from 'redux-saga/effects';
import api ,{CollectionToObject} from "../api/api";
import {saveGloopData,getUserData,getGloopData,getLocalGloops} from "../localStorage";




/*************************getUserGloops*********************************/
function* getUserGloopsSaga() {
	const state = yield select();
	if(!state.gloops){
		if(window.UserId){
			const gloops = yield call(api.getUserGloops, window.UserId);
			yield put({type: "SET GLOOPS", data: CollectionToObject(gloops,'ID')});
		}
		else {
			yield put({type: "SET GLOOPS", data: getLocalGloops()});
		}
	}
}

function* getUserGloops() {
	yield takeEvery("GET GLOOPS", getUserGloopsSaga);getGloopData
}
/*************************getUserGloops end*********************************/



/*************************ACTIVATE*********************************/

function* ActivateGloopSaga(action) {
	yield put({type: "SET ACTIVE GLOOP", id: action.id});
	yield put({type: "SET SCREEN", data : 'start'});
	yield put({type: "SET ERROR", data : ''});
	let gloops = yield select((state => state.gloops));
	if(!gloops){
		yield put({type: "GET GLOOPS"});
		yield take('SET GLOOPS');
		gloops = yield select((state => state.gloops));
	}
	if(gloops[action.id]){

	}
	if (!gloops[action.id].data) {
		const gloop = yield call(api.getGloopOptions, action.id);
		yield putResolve({
			type: 'UPDATE GLOOP DATA',
			id: action.id,
			data: gloop
		});
	}
	//yield put({type : 'UPDATE VIDEO VERSION'});
	gloops = yield select((state => state.gloops));

	yield put({type: "ACTIVATE GLOOP OPTIONS", id: gloops[action.id].data.original_gloop[0]});
}

function* ActivateGloop() {
	yield takeEvery("ACTIVATE", ActivateGloopSaga);
}


/*************************ACTIVATE end*********************************/



/*************************ACTIVATE OPTIONS*********************************/

function* ActivateGloopOptionsSaga(action) {
	const gloopsOptions = yield select(state => state.gloopsOptions);
	if (!gloopsOptions[action.id]) {
		const gloop = yield call(api.getGloopOptions, action.id);
		yield put({
			type: 'UPDATE GLOOP OPTIONS',
			data: {
				id: action.id,
				status: 'loaded',
				data: gloop
			}
		});
	}
}

function* ActivateGloopOptions() {
	yield takeEvery("ACTIVATE GLOOP OPTIONS", ActivateGloopOptionsSaga);
}

/*************************ACTIVATE OPTIONS end*********************************/

/*************************ACTIVATE OPTIONS*********************************/

function* newGloopSaga(action) {
	yield put({type: "SET SCREEN", data : 'start'});
	yield put({type: "SET ERROR", data : ''});
	yield put({type: "LOADING", status : true});
	yield put({type: "SET ACTIVE TAB", tabName : 'textcontrol'});
	let response;
	let gloop = null;
	let gloopsOptions = yield select(state => state.gloopsOptions);
	if(!gloopsOptions[action.id]){
		yield put({type: "ACTIVATE GLOOP OPTIONS", id: action.id});
		yield take('UPDATE GLOOP OPTIONS');
		gloopsOptions = yield select(state => state.gloopsOptions);
	}

	let gloops = yield select((state => state.gloops));
	if(!gloops){
		yield put({type: "GET GLOOPS"});
		yield take('SET GLOOPS');
		gloops = yield select((state => state.gloops));
	}

	for(let key in gloops){
		if(gloops[key].data && gloops[key].data.original_gloop[0]==action.id && !gloops[key].data.shared ){
			gloop = key;
			break;
		}
	}


	if(gloop){
		!document.getElementById('static-gloop-container') && window.jQuery('body').css({position : 'fixed'});
		yield put({
			type: 'ACTIVATE',
			id: gloop
		});
	} else {
		gloop = gloopsOptions[action.id].data;
		const textData= (gloop) ? (gloop.default_text ? gloop.default_text : 'text').split('|') : '';
		let data = {};
		let IDtime = new Date();
		if(!window.UserId){
			data.customization_url = window.gloopVideoRoot+'free-users/anonim_'+action.id+'-'+IDtime.getFullYear()+(IDtime.getMonth()+1)+IDtime.getDate()+IDtime.getHours()+IDtime.getMinutes()+IDtime.getSeconds()+'.mp4';
		}
		data.selected_visual_object = 0;
		data.original_gloop = [action.id];
		data.selected_audio = gloop.audio_option_1;
		data.selected_background = gloop.background_option_1;
		data.offers = String(Object.keys(gloopsOptions));
		data.offerIndex = data.offers.split('-');
		data.variableText = textData[0].split('###');
		data.customized_text = (data.offerIndex.length < 2) ? data.variableText[0] : data.variableText[Number(data.offerIndex[data.offerIndex.length - 1])];
		data.title = 'Customized '+ gloop.postTitle;
		data.user = window.UserId;
		data.color = textData[2] ? textData[2] :'#000000';
		data.font = textData[1]  ? textData[1] :'Arial';
		data.size = textData[6] ? textData[6] : 28;
		data.xoffset = textData[3] ? textData[3] : 0;
		data.yoffset = textData[4] ? textData[4] : 0;
		data['box-width'] = textData[5] ? textData[5] : 150;
		data.textWidth =  textData[5] ? 24*1.92 + parseInt(textData[5]) : 150;
		// data.textHeight = textData[5] ? textData[5] : 150;EDIT GLOOP
		data.textHeight = textData[7] ? 24*1.92 + parseInt(textData[7]) : data.textWidth;
		// data.xoffset = textData[3] ? textData[3].split('-')[1] : 0;
		// data.yoffset = textData[3] ? textData[3].split('-')[0] : 0;
		// data.textWidth = textData[4] ? textData[4].split('-')[1] : 200;
		// data.textHeight = textData[4] ? textData[4].split('-')[0] :200;
		data.status = 'draft';
		if(textData.length < 4){
			yield put({
				type: 'SET ERROR',
				data: 'invalidData'
			});
			return;
		}
		if (window.UserId) {
			response = yield call(api.newGloop, JSON.stringify(data));
		} else {
			response = yield call(api.newAnonimGloop, JSON.stringify(data));
			data.short_url = response.short_url;
			response = {
				id: IDtime
			}
		}
		yield put({
			type: 'ADD GLOOP',
			id: response.id,
			data: !window.UserId ? data : null
		});
		saveGloopData({
			id: response.id,
			data: data
		});
		if (!window.UserId){
			yield put({
				type: 'EDIT GLOOP',
				id: response.id,
				data: {}
			});
		}
		!document.getElementById('static-gloop-container') && window.jQuery('body').css({position : 'fixed'});
		yield put({
			type: 'ACTIVATE',
			id: response.id
		});
		if(window.UserId){
			yield take('UPDATE GLOOP DATA');
			yield put({
				type: 'EDIT GLOOP',
				id: response.id,
				data: {}
			});
		}
	}
}

function* newGloop() {
	yield takeEvery("NEW GLOOP", newGloopSaga);
}

/*************************ACTIVATE OPTIONS end*********************************/

/*************************SAVE*********************************/
let log =[];

function* saveGloopSaga(action) {
	let data;
	let gloop = yield select((state => state.gloops[action.id]));

		yield put({type : 'LOADING' , status : true});
		let logText = '' ;
		for(let key in action.data){
			logText+=key+':'+action.data[key];
		}
		log.push(action.log ? action.log: logText);
		if(window.UserId){

			if (action.sendToServer) {
				data = yield call(api.saveGloop, action.id, gloop.data, JSON.stringify(log));
				yield putResolve({
					type: 'UPDATE GLOOP DATA',
					id: action.id,
					data: data
				});
				log =[];
				yield put({type : 'UPDATE VIDEO VERSION'});
			}
		}
		else {
			if (action.sendToServer) {
				data = yield call(api.newAnonimGloop, JSON.stringify(gloop.data), JSON.stringify(log));
				if(!action.data.short_url) {
					action.data.short_url = data.short_url;
				}
				log =[];
				action.data.saved = true;
				yield put({type : 'UPDATE VIDEO VERSION'});
			}
			else {
				data = Object.assign({},gloop.data,action.data)
			}
			yield putResolve({
				type: 'UPDATE GLOOP DATA',
				id: action.id,
				data: data
			});
			saveGloopData({
				id: action.id,
				data: action.data
			});
		}

	//yield put({type : 'UPDATE VIDEO VERSION'});
	yield put({type : 'LOADING' , status : false});

	//yield takeEvery("SAVE", ActivateGloopSaga);
}

function* saveGloop() {
	yield takeLatest("EDIT GLOOP", saveGloopSaga);
}

/*************************SAVE end*********************************/


/*************************SHARE*************************************/

function* shareGloopSaga(action) {
	let gloop = yield select((state => state.gloops[action.id]));
	yield call(api.share, action.id,gloop.data.original_gloop[0],action.to);
	gloop.data.shared =  true;
}

function* shareGloop(){
	yield takeEvery("SHARE", shareGloopSaga);
}
/*************************SHARE end*********************************/



function* Sagas(action) {
	yield all([
		ActivateGloop(),
		ActivateGloopOptions(),
		saveGloop(),
		getUserGloops(),
		newGloop(),
		shareGloop()
	]);
}

export default Sagas;
//api.getGloopOptions(911);

